<template>
  <a
    class="w-full h-[189px] mb-[28px] flex cursor-pointer overflow-hidden"
    @click="handleClick"
  >
    <!-- 左侧图片区域 -->
    <div
      class="flex-shrink-0 w-[210px] h-[189px] rounded-tl-[10px] rounded-bl-[10px] overflow-hidden"
    >
      <img :src="coverUrl" :alt="title" class="w-full h-full object-cover" />
    </div>

    <!-- 右侧内容区域：上下两半布局 -->
    <div
      class="flex-1 h-[189px] pt-[30px] pr-[40px] pb-[20px] pl-[30px] rounded-tr-[10px] rounded-br-[10px] bg-[#F5F5F5] flex flex-col items-start"
    >
      <!-- 上半部分：标题，最多两行 -->
      <div class="flex-1 flex items-start">
        <div
          :class="[
            'text-[#161616] text-[30px] text-left line-clamp-2',
            isEnglish
              ? 'font-br-hendrix font-medium leading-[125%] tracking-[-0.025em]'
              : 'font-normal leading-[155%] tracking-normal',
          ]"
        >
          {{ title }}
        </div>
      </div>

      <!-- 下半部分：已读标签 -->
      <div class="flex-1 flex items-end">
        <ViewedBadge v-if="viewed" variant="inline" />
      </div>
    </div>
  </a>
</template>

<script lang="ts">
import ViewedBadge from './ViewedBadge.vue';
interface Props {
  materialId: string;
  title: string;
  coverUrl: string;
  jumpUrl: string;
  viewed: boolean;
  isEnglish?: boolean;
  tags?: string[];
}
const __sfc_main = {};
__sfc_main.props = {
  materialId: {
    key: "materialId",
    required: true,
    type: String
  },
  title: {
    key: "title",
    required: true,
    type: String
  },
  coverUrl: {
    key: "coverUrl",
    required: true,
    type: String
  },
  jumpUrl: {
    key: "jumpUrl",
    required: true,
    type: String
  },
  viewed: {
    key: "viewed",
    required: true,
    type: Boolean
  },
  isEnglish: {
    key: "isEnglish",
    required: false,
    type: Boolean,
    default: false
  },
  tags: {
    key: "tags",
    required: false,
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  function handleClick() {
    emit('click', props.materialId, props.jumpUrl);
  }
  return {
    handleClick
  };
};
__sfc_main.components = Object.assign({
  ViewedBadge
}, __sfc_main.components);
export default __sfc_main;
</script>
